import ReactOnRails from 'react-on-rails/client';
import SimpleGallery from '../../src/SimpleGallery/ror_components/SimpleGallery.client.jsx';

ReactOnRails.register({SimpleGallery});